import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconEncryptedAddLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.529 21.344c-2.13-.714-3.835-2.042-5.112-3.985C5.139 15.417 4.5 13.331 4.5 11.1V6.597c0-.38.11-.722.328-1.026.218-.303.5-.524.847-.66l5.692-2.125c.214-.077.425-.116.633-.116.208 0 .419.039.633.116l5.692 2.125c.347.136.629.357.847.66.219.304.328.646.328 1.026v4.496c0 .213-.072.39-.216.535a.726.726 0 0 1-.534.215.725.725 0 0 1-.535-.215.726.726 0 0 1-.215-.535V6.586a.298.298 0 0 0-.053-.173.318.318 0 0 0-.149-.115l-5.692-2.125a.282.282 0 0 0-.106-.02.282.282 0 0 0-.106.02L6.202 6.298a.318.318 0 0 0-.149.115.298.298 0 0 0-.053.173V11.1c0 2.017.567 3.85 1.7 5.5s2.567 2.75 4.3 3.3c.196.064.342.19.438.38a.74.74 0 0 1 .05.582.712.712 0 0 1-.38.438.745.745 0 0 1-.58.044ZM17 18.5h-2.25a.726.726 0 0 1-.534-.216.726.726 0 0 1-.216-.534c0-.213.072-.391.216-.535A.727.727 0 0 1 14.75 17H17v-2.25c0-.213.072-.39.216-.535A.727.727 0 0 1 17.75 14a.73.73 0 0 1 .535.215.726.726 0 0 1 .215.535V17h2.25c.212 0 .39.072.534.216a.726.726 0 0 1 .216.534c0 .213-.072.39-.216.534a.726.726 0 0 1-.534.216H18.5v2.25c0 .212-.072.39-.216.534a.726.726 0 0 1-.534.216.725.725 0 0 1-.535-.216.726.726 0 0 1-.215-.534V18.5Zm-5.717-3.75h1.434a.456.456 0 0 0 .353-.17.395.395 0 0 0 .1-.372l-.476-2.616c.314-.135.567-.346.759-.635A1.7 1.7 0 0 0 13.74 10c0-.479-.17-.888-.511-1.23a1.678 1.678 0 0 0-1.23-.51c-.479 0-.888.17-1.229.51-.34.342-.51.751-.51 1.23 0 .35.096.668.287.957.192.289.445.5.759.635l-.475 2.616c-.034.135 0 .26.099.372.1.113.217.17.353.17Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconEncryptedAddLine;
